import styled from 'styled-components'

import breakpoints from '../../constants/ui/breakpoints'

const ServerCrestronStyled = styled.div`
  width: 100%;

  .section-one {
    .badge {
      position: relative;
      background: ${({ theme }) => theme.backgroundGradientHighlight};
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      padding: 0.25rem 1rem;
      margin-bottom: 1.5rem;
      text-transform: uppercase;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 0.375rem;
        padding: 1px;
        background: ${({ theme }) => theme.backgroundGradientHighlight};
        -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
      }
    }

    .badge-text {
      letter-spacing: 0.05em;
    }

    .title {
      max-width: 700px;
      margin-bottom: 1.25rem;
    }

    .text {
      margin-bottom: 2.5rem;
      opacity: 0.8;

      @media (max-width: ${breakpoints.screenSM}) {
        margin-bottom: 2rem;
      }
    }

    .img-container {
      position: relative;
      margin-bottom: 2rem;

      @media (max-width: ${breakpoints.screenLG}) {
        margin-bottom: 0;
      }
    }

    .img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      max-width: 440px;

      @media (max-width: ${breakpoints.screenSM}) {
        max-width: 250px;
      }
    }

    .btn-group {
      display: flex;
      align-items: center;
      gap: 1rem;
      z-index: 1;

      @media (max-width: ${breakpoints.screenSM}) {
        flex-direction: column;
        width: 100%;
      }
    }
  }

  .section-two {
    .title {
      max-width: 600px;
      margin-bottom: 1.5rem;
    }

    .text {
      max-width: 610px;
      margin-bottom: 3.5rem;
      opacity: 0.8;

      @media (max-width: ${breakpoints.screenLG}) {
        margin-bottom: 3rem;
      }
    }

    .subtitle-box {
      background-color: ${({ theme }) => theme.backgroundLight};
      border-radius: 0.375rem;
      width: 85%;
      padding: 0.75rem;
      margin-bottom: 2.5rem;
      text-transform: uppercase;
      letter-spacing: 0.1em;

      @media (max-width: ${breakpoints.screenLG}) {
        width: 100%;
      }
    }

    .devices {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      justify-content: space-between;
      width: 85%;
      margin-bottom: 5rem;
      text-align: center;

      @media (max-width: ${breakpoints.screenLG}) {
        width: 100%;
      }

      @media (max-width: ${breakpoints.screenSM}) {
        grid-template-columns: repeat(2, 1fr);
        row-gap: 1.5rem;
        margin-bottom: 3rem;
      }
    }

    .device-text {
      opacity: 0.7;
    }

    .device-img {
      max-width: 150px;
      margin-bottom: 1rem;
    }
  }

  .section-three {
    background: linear-gradient(180deg, #e3f2f2 0%, rgba(227, 242, 242, 0) 100%);

    .title {
      max-width: 600px;
      margin-bottom: 1.5rem;
    }

    .text {
      max-width: 610px;
      margin-bottom: 3rem;
      opacity: 0.8;
    }

    .items {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 4rem 4rem;
      width: 85%;
      margin-top: 2.5rem;

      @media (max-width: ${breakpoints.screenMD}) {
        grid-template-columns: repeat(2, 1fr);
        width: 100%;
      }

      @media (max-width: ${breakpoints.screenSM}) {
        grid-template-columns: 1fr;
      }
    }

    .item {
      text-align: left;

      @media (max-width: ${breakpoints.screenMD}) {
        text-align: center;
      }
    }

    .item-img {
      margin-bottom: 1rem;
    }

    .item-text {
      max-width: 185px;
      margin-top: 0.5rem;

      @media (max-width: ${breakpoints.screenMD}) {
        max-width: 220px;
        margin: 0.5rem auto 0;
      }

      @media (max-width: ${breakpoints.screenSM}) {
        max-width: 240px;
      }

      &.opacity {
        opacity: 0.8;
      }
    }
  }

  .section-four {
    .title {
      max-width: 730px;
      margin-bottom: 0.75rem;
    }

    .subtitle {
      max-width: 690px;
      margin-bottom: 1.5rem;

      span {
        background: linear-gradient(0deg, #008996, #52e8c1);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        -webkit-box-decoration-break: clone;
      }
    }

    .text {
      max-width: 610px;
      margin-bottom: 3.5rem;
      opacity: 0.8;

      @media (max-width: ${breakpoints.screenSM}) {
        margin-bottom: 2rem;
      }
    }

    .img-box {
      background-color: ${({ theme }) => theme.backgroundPrimary};
      border-radius: 1.25rem;
      box-shadow: ${({ theme }) => theme.boxShadowPrimary};
      width: 60%;
      padding: 4rem 2.5rem;

      @media (max-width: ${breakpoints.screenMD}) {
        width: 80%;
      }

      @media (max-width: ${breakpoints.screenSM}) {
        width: 100%;
      }
    }

    .img {
      margin-left: 10%;
    }
  }

  .section-five {
    .title {
      @media (max-width: ${breakpoints.screenSM}) {
        max-width: 350px;
      }
    }

    .item-group {
      display: flex;
      justify-content: space-between;
      gap: 3rem;
      width: 90%;

      @media (max-width: ${breakpoints.screenMD}) {
        width: 100%;
      }

      @media (max-width: ${breakpoints.screenSM}) {
        flex-direction: column;
        align-items: center;
      }

      &.mb-2 {
        margin-bottom: 2rem;
      }
    }

    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      width: calc(33.33% - 0.5rem);

      @media (max-width: ${breakpoints.screenSM}) {
        width: 100%;
      }
    }

    .subtitle {
      max-width: 220px;
      margin-bottom: 1rem;
    }

    .text {
      max-width: 310px;
    }

    .img {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 75px;
      margin-bottom: 1rem;
    }
  }

  .section-six {
    background: ${({ theme }) => theme.backgroundPrimary};
    border-bottom: 1px solid ${({ theme }) => theme.borderPrimary};
    padding-bottom: 5rem;

    @media (max-width: ${breakpoints.screenSM}) {
      padding-bottom: 3rem;
    }
  }
`

export default ServerCrestronStyled
